/*!
  Pioneer WFRIA ToggleSwitchKnob v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["ToggleSwitchKnob"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("ToggleSwitchKnob") < 0) {
    window.__PIONEER_GLOBAL__.components.push("ToggleSwitchKnob");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["cssToggleSwitchKnob", "cssToggleSwitchKnobBorder", "cssToggleSwitchKnobCircle", "cssToggleSwitchKnobCircleShadow", "cssToggleSwitchKnobShadow", "cssToggleSwitchKnobOuterCircle"];
import PropTypes from "prop-types";
import React from "react";
import { useUniqueId } from "../common/hooks";
import { TOGGLESWITCH_KNOB, TOGGLESWITCH_KNOB_CIRCLE } from "../themes/common/classes";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

function ToggleSwitchKnob(_ref) {
  let {
    cssToggleSwitchKnob,
    cssToggleSwitchKnobBorder,
    cssToggleSwitchKnobCircle,
    cssToggleSwitchKnobCircleShadow,
    cssToggleSwitchKnobShadow,
    cssToggleSwitchKnobOuterCircle
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const linearGradientId = useUniqueId("wf-toggleswitch-knob-linear-gradient");
  return _jsx("div", {
    className: TOGGLESWITCH_KNOB,
    css: cssToggleSwitchKnob,
    children: _jsx("div", {
      css: cssToggleSwitchKnobShadow,
      children: _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        className: "wf-toggleswitchknob",
        focusable: "false",
        children: [_jsx("defs", {
          children: _jsxs("linearGradient", {
            id: linearGradientId,
            x1: "13",
            y1: "0.5",
            x2: "13",
            y2: "25.5",
            gradientUnits: "userSpaceOnUse",
            children: [_jsx("stop", {
              offset: "0",
              stopColor: "#fff"
            }), _jsx("stop", {
              offset: "1",
              stopColor: "#f0f1f2"
            })]
          })
        }), _jsx("circle", {
          cx: "13",
          cy: "13",
          r: "12.5",
          fill: `url(#${linearGradientId})`,
          css: cssToggleSwitchKnobOuterCircle
        }), _jsx("path", {
          d: "M13,1A12,12,0,1,1,1,13,12,12,0,0,1,13,1m0-1A13,13,0,1,0,26,13,13,13,0,0,0,13,0Z",
          css: cssToggleSwitchKnobBorder
        }), _jsx("circle", {
          cx: "13",
          cy: "14",
          r: props.innerCircleRadius,
          css: cssToggleSwitchKnobCircleShadow
        }), _jsx("circle", {
          cx: "13",
          cy: "13",
          r: props.innerCircleRadius,
          className: TOGGLESWITCH_KNOB_CIRCLE,
          css: cssToggleSwitchKnobCircle
        })]
      })
    })
  });
}

ToggleSwitchKnob.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Knob inner circle css. */
  innerCircleRadius: PropTypes.string.isRequired,

  /** Knob css. */
  cssToggleSwitchKnob: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** Knob border css. */
  cssToggleSwitchKnobBorder: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** Knob inner circle css. */
  cssToggleSwitchKnobCircle: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** Knob inner circle shadow css. */
  cssToggleSwitchKnobCircleShadow: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** Knob outer circle css. */
  cssToggleSwitchKnobOuterCircle: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** Knob Shadow css. */
  cssToggleSwitchKnobShadow: PropTypes.object // eslint-disable-line react/forbid-prop-types

} : {};
ToggleSwitchKnob.defaultProps = {
  cssToggleSwitchKnob: null,
  cssToggleSwitchKnobBorder: null,
  cssToggleSwitchKnobCircle: null,
  cssToggleSwitchKnobShadow: null,
  cssToggleSwitchKnobOuterCircle: null,
  cssToggleSwitchKnobCircleShadow: null
};
export default ToggleSwitchKnob;